module.exports = __webpack_public_path__ + "assets/img/cdc738bca8eb058cd1f0998b0243d660.png";